import { frontPicEnum } from "@enums";
export const state = {
  gameId: window["gameId"] || window["gameid"] || window["gameID"], // 游戏id
  config: {}, // 问卷配置信息
  isAnswer: false, // 是否已经作答
  isAward: false, // 是否已经发奖
  canSurveyTimeStart: true, // 问卷是否开始
  isSurveyEnd: false, // 问卷是否结束
  questionFlag: window["id"], // 问卷标识
  title: "", // 问卷标题
  activityStartTime: "", // 开始时间
  activityEndTime: "", // 结束时间
  latestEditTime: "", // 最新编辑时间
  loginLimit: "", // 是否需要登陆
  sendType: "", // 发奖类型
  cover: "", // 封面信息
  finishConfig: "", // 结果配置
  currentIndex: -1, // 当前第几题
  currentMatrixPageIndex: 0, // 当前矩阵单选页数
  questionList: [], // 题目列表
  chooseAnswer: [], // 当前所选下标数组 [0,1] 代表选择第1，2项
  matrixAnswer: [], // 记录矩阵选项下标数组 [0,1]代表第一行选第一项，第二行选第二项
  resultList: [], // 答案记录数组
  langList: [], // 语言列表
  translate: {}, // 翻译数据
  firstRequest: true, // 首次请求问卷接口，后续重新请求（切换语言）仅更新翻译id
  gameName: "", // 游戏名，
  surveyStartTime: "", // 开始问卷时间
  enterQuestionTime: "", // 记录进入某一题的时间
  loadingState: true, // 是否加载中
  coverAwardList: [], // 封面奖励列表
  frontPicType: frontPicEnum.DEFAULT, // 封面类型
  coverPicList: {
    type_h:
      "https://cdnimages.awselbcombine.com/public_images/one_image/2024/01/17061826595445.jpg",
    type_v:
      "https://cdnimages.awselbcombine.com/public_images/one_image/2024/01/17061826595445.jpg",
  },
  coverFontColor: "#fff", // 封面字体颜色
  hideLogin: false, // 是否隐藏登录
};
